import { memo } from 'react';

function NewPickUpIcon({ backgroundColor, borderColor, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M22.78 18V6L12.39 0L2 6V18L12.39 24L22.78 18Z" fill={backgroundColor} />
      <path
        d="M12.39 1.15L21.78 6.57V17.42L12.39 22.84L3 17.42V6.58L12.39 1.15ZM12.39 0L2 6V18L12.39 24L22.78 18V6L12.39 0Z"
        fill={borderColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1974 8.90477V10.6204H15.4474V8.90477H13.9716V7.15477H15.4474V5.58301H17.1974V7.15477H18.913V8.90477H17.1974ZM6.61987 8.02977C6.61987 7.54652 7.01162 7.15477 7.49487 7.15477H12.5803V8.90477H8.36987V16.1261H15.4474V11.9637H17.1974V17.0011C17.1974 17.4844 16.8056 17.8761 16.3224 17.8761H7.49487C7.01162 17.8761 6.61987 17.4844 6.61987 17.0011V8.02977Z"
        fill={borderColor}
      />
    </svg>
  );
}

export default memo(NewPickUpIcon);
